import React from "react";
import {
  BrowserRouter as Router,
  Navigate,
  Route,
  Routes,
} from "react-router-dom";
import { observer } from "mobx-react";
import "./App.css";

import {
  Login,
  Register,
  Home,
  MakeAPlan,
  Settings,
  UserPreferences,
  Waitlist,
} from "./pages";

import { ProtectedLayout } from "./components";
import { userStore } from "./modules/stores";

const isWaitlistMode = process.env.REACT_APP_WAITLIST_MODE === "true";

console.log({ isWaitlistMode });

const App = () => {
  const { isLoggedIn } = userStore;

  if (isWaitlistMode) {
    return (
      <Router>
        <Routes>
          <Route path="/" element={<Waitlist />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Router>
    );
  }

  return (
    <Router>
      <Routes>
        <Route
          path="/"
          element={
            isLoggedIn ? <Navigate to="/app/home" replace /> : <Waitlist />
          }
        />
        <Route
          path="/login"
          element={isLoggedIn ? <Navigate to="/app/home" replace /> : <Login />}
        />
        <Route path="/register" element={<Register />} />
        <Route path="/app" element={<ProtectedLayout />}>
          <Route index element={<Navigate to="/app/home" replace />} />
          <Route path="/app/home" element={<Home />} />
          <Route path="/app/make-a-plan" element={<MakeAPlan />} />
          <Route path="/app/preferences" element={<UserPreferences />} />
          <Route path="/app/settings" element={<Settings />} />
        </Route>
        <Route
          path="*"
          element={<Navigate to={isLoggedIn ? "/app/home" : "/"} replace />}
        />
      </Routes>
    </Router>
  );
};

export default observer(App);
